// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OMgU","content":"styles_content__1t5SD"};